/**
 * Failures from the latest Images Bulk Upload batch for the page snackbar
 * @module services/images/redux/support-error-reducer
 */
import {
  SHOW_BULK_UPLOAD_SUPPORT_ERROR,
  CLEAR_BULK_UPLOAD_SUPPORT_ERROR,
  SET_BULK_UPLOAD_BATCH_SUMMARY,
} from './actions'

export const initialState = null

export default function bulkUploadSupportErrorReducer (
  state = initialState,
  { type, payload } = {},
) {
  switch (type) {
    case SHOW_BULK_UPLOAD_SUPPORT_ERROR: {
      const report = payload?.report
      if (!report) {
        return state
      }
      // A new batch replaces the previous one so the snackbar never mixes runs
      const isSameBatch = Boolean(state && report.batchId && state.batchId === report.batchId)

      return {
        batchId: report.batchId || null,
        reports: isSameBatch ? [...state.reports, report] : [report],
        summary: isSameBatch ? state.summary : null,
      }
    }
    case SET_BULK_UPLOAD_BATCH_SUMMARY: {
      const summary = payload?.summary
      if (!summary || !state || state.batchId !== summary.batchId) {
        return state
      }
      return { ...state, summary }
    }
    case CLEAR_BULK_UPLOAD_SUPPORT_ERROR:
      return null
    default:
      return state
  }
}
